import type { SVGProps } from 'react';

export const AsteriskIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M11.9998 21.9999C11.4478 21.9999 10.9998 21.5519 10.9998 20.9999V13.7312L4.70514 17.3652C4.54781 17.4559 4.37581 17.4999 4.20647 17.4999C3.85981 17.4999 3.52381 17.3212 3.33981 16.9999C3.06381 16.5212 3.22781 15.9106 3.70514 15.6346L10.0009 11.9999L3.70514 8.36525C3.22781 8.08925 3.06381 7.47725 3.33981 6.99992C3.61448 6.52259 4.22647 6.35592 4.70514 6.63459L10.9998 10.2689V2.99994C10.9998 2.44794 11.4478 1.99994 11.9998 1.99994C12.5518 1.99994 12.9998 2.44794 12.9998 2.99994V10.2686L19.2944 6.6346C19.7744 6.35727 20.3838 6.52393 20.6598 6.99993C20.9358 7.4786 20.7718 8.08926 20.2944 8.36526L13.9983 12.0001L20.2931 15.6346C20.7704 15.9106 20.9344 16.5226 20.6584 16.9999C20.4732 17.321 20.1375 17.4997 19.7924 17.4999C19.6233 17.4998 19.4516 17.4571 19.2944 17.3652L12.9998 13.7312V20.9999C12.9998 21.5519 12.5518 21.9999 11.9998 21.9999Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
